// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';

// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_DATA = 'LOADING_DATA';
export const STOP_LOADING_UI = 'STOP_LOADING_UI';

// Data reducer types
export const SET_THOUGHTS = 'SET_THOUGHTS';
export const SET_THOUGHT = 'SET_THOUGHT';
export const LIKE_THOUGHT = 'LIKE_THOUGHT';
export const UNLIKE_THOUGHT = 'UNLIKE_THOUGHT';
export const DELETE_THOUGHT = 'DELETE_THOUGHT';
export const POST_THOUGHT = 'POST_THOUGHT';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';